import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-exhibitor-pdf-dialog',
  templateUrl: './exhibitor-pdf-dialog.component.html',
  styleUrls: [ './exhibitor-pdf-dialog.component.scss' ]
})

export class ExhibitorPDFDialogComponent implements OnInit, OnDestroy {

  public Editor = ClassicEditor

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  // Variáveis para upload
  selectedFile: File | null = null;
  selectedFileName: any | null = null;
  storedPDF: any | null = null;
  pdfName: any = "";
  public image_path: string;

  constructor (
    public matDialogRef: MatDialogRef<ExhibitorPDFDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  ngOnDestroy () { }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      src: new FormControl(data.src),
      file: new FormControl(data.file),
      key: new FormControl(data.key, [ Validators.required ]),
      name: new FormControl(data.name, [ Validators.required ]),

    });

    this.pdfName = data.pdf_name;
    this.selectedFileName = data.file
    this.storedPDF = data.src;

    return form
  }

  onFileSelected (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFile = file;
      this.entityForm.controls.file.setValue(file.name);
      this.selectedFileName = file.name;
      this.previewImage(this.selectedFile)
    }
  }

  previewImage (selectedFile: any) {

    this.storedPDF = selectedFile.name;
    
    /*
    var reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = (_event) => {
      this.storedPDF = reader.result;
    }
      */
  }



}

